import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { COLORES } from '../../../../../config/colores'
import PrintIcon from '@material-ui/icons/Print'
import { CircularProgress } from '@material-ui/core'

export default function ConfirmacionPesadoDestare (props) {
  const { cpe, showReimpresion } = props

  const [imprimiendo, setImprimiendo] = useState(false)
  const startTime = () => 5
  const [seconds, setSeconds] = useState(startTime)

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
      if (seconds === 0) {
        clearInterval(interval)
        setImprimiendo(false)
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  })

  const camionConCerealAdherido = async () => {
    setImprimiendo(true)
    setSeconds(startTime)
    props.reimpresionCerealAdherido(cpe.numero)
  }

  const reimprimir = () => {
    setImprimiendo(true)
    setSeconds(startTime)
    props.reimprimirTicket(cpe.numero)
  }

  return (
    <div className='dialog-pesado-destare text-center'>
      <div className='cabecera-show-pesado'>
        <h1
          className='text-center'
          style={{ fontSize: '2.3rem' }}
        >
          Por favor verifique su peso de tara
        </h1>
      </div>

      <div className='confirmacion-chofer'>
        <div className='container-datos-confirmacion-destare'>
          <div className='box-datos-confirmacion'>
            <h1 className='title-box-confirmacion'>Número CTG</h1>
            { cpe && cpe.numero && <h1
              className='valor-datos-confirmacion-pesado'
            >
              {cpe.numero}
            </h1>
            }
          </div>
          <div className='box-datos-confirmacion'>
            <h1 className='title-box-confirmacion'>Peso Tara</h1>
            { cpe && cpe.pesoTara && <h1
              className='valor-datos-confirmacion-pesado'
            >
              {cpe.pesoTara}
            </h1>
            }
          </div>
        </div>
        <div>
          { showReimpresion
            ? <div className='cereal-adherido-destare'>
              <div className='leyenda-cereal-adherido' >
                <h3>Para <b>diferencias en peso de tara</b> puede <b>reimprimir</b> el ticket de descarga con leyenda de cereal adherido </h3>
              </div>
              <Button
                className='btn-reimpresion-cereal-adherido'
                onClick={() => camionConCerealAdherido()}
                style={{ backgroundColor: COLORES.blue.primary, border: 'none' }}
              >
                <div className='container-card-acciones-destare'>
                  {(!imprimiendo)
                    ? <div className='circular-progress-destare'>
                      <PrintIcon style={{ color: '#ffffff' }} fontSize='large' />
                      <h2 style={{ margin: '0 15px', fontSize: '1.6rem', color: '#ffffff' }}>Reimprimir</h2>
                    </div>
                    : <div className='circular-progress-destare'>
                      <CircularProgress className='circular-progress-impresion' />
                      <h4 style={{ color: '#ffffff', fontSize: '1.6rem', margin: '0 15px' }}>Imprimiendo</h4>
                    </div>
                  }
                </div>
              </Button>
            </div>
            : <div style={{ margin: '5% 0' }} >
              <Button
                className='btn-reimpresion-cereal-adherido'
                onClick={() => reimprimir(cpe.numero)}
                style={{ backgroundColor: COLORES.blue.primary, border: 'none' }}
              >
                <div className='container-card-acciones-destare'>
                  {(!imprimiendo)
                    ? <div className='circular-progress-destare'>
                      <PrintIcon style={{ color: '#ffffff' }} fontSize='large' />
                      <h2 style={{ margin: '0 15px', fontSize: '1.6rem', color: '#ffffff' }}>Reimprimir</h2>
                    </div>
                    : <div
                      className='circular-progress-destare'
                      style={{ backgroundColor: COLORES.blue.primary }}
                    >
                      <CircularProgress className='circular-progress-impresion' />
                      <h4 style={{ color: '#ffffff', fontSize: '1.6rem', margin: '0 15px' }}>Imprimiendo</h4>
                    </div>
                  }
                </div>
              </Button>
            </div>}
          <div>
            { cpe && <h1>¡Muchas gracias {cpe.chofer} !</h1> }
          </div>
        </div>
      </div>
    </div>
  )
}
